export default "__VITE_ASSET__DSp9BOzb__"